<template>
  <v-container>
    <v-card class="pa-5" outlined>
      <!-- Card Header -->
      <v-card-title>
        <v-icon large class="mr-3">mdi-account-plus</v-icon>
        <span class="text-h5">Accept Invitation</span>
      </v-card-title>
      <v-card-subtitle>
        Complete the form below to create your account.
      </v-card-subtitle>

      <!-- Card Body -->
      <v-card-text>
        <v-form ref="acceptForm" v-model="valid" lazy-validation>
          <v-row>
            <!-- Avatar with Hover Effect -->
            <v-col cols="12" md="4" class="d-flex flex-column align-items-center">
              <div class="avatar-container">
                <v-avatar size="128" class="mb-4">
                  <img
                    :src="avatarPreview || defaultAvatar"
                    alt="Avatar"
                    class="circle-image"
                  />
                </v-avatar>
                <div class="hover-overlay" @click="triggerImageUpload">
                  <v-icon large>mdi-camera</v-icon>
                </div>
              </div>
              <v-file-input
                ref="imageInput"
                accept="image/*"
                v-model="form.avatarFile"
                class="d-none"
                @change="onAvatarChange"
              ></v-file-input>
            </v-col>

            <!-- User Info Fields -->
            <v-col cols="12" md="8">
              <v-text-field
                label="Username"
                v-model="form.username"
                :rules="[v => !!v || 'Username is required']"
                required
                outlined
              ></v-text-field>

              <v-text-field
                label="Password"
                type="password"
                v-model="form.password"
                :rules="[v => !!v || 'Password is required']"
                required
                outlined
              ></v-text-field>

              <v-text-field
                label="Confirm Password"
                type="password"
                v-model="form.confirmPassword"
                :rules="[v => !!v || 'Please confirm your password']"
                required
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Create Account Button -->
          <v-btn
            color="primary"
            block
            class="mt-1"
            :disabled="!valid"
            @click="acceptInvite"
          >
            Create Account
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/plugins/axios";
import defaultAvatar from '@/assets/default-avatar.png';
export default {
  data() {
    return {
      valid: false,
      defaultAvatar: defaultAvatar,
      avatarPreview: null,
      form: {
        username: "",
        password: "",
        confirmPassword: "",
        avatarFile: null,
      },
    };
  },
  methods: {
    /**
     * Handle avatar file changes and create a local preview.
     */
    onAvatarChange() {
      if (this.form.avatarFile) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatarPreview = e.target.result;
        };
        reader.readAsDataURL(this.form.avatarFile);
      } else {
        this.avatarPreview = null;
      }
    },
    /**
     * Trigger file input click on the overlay.
     */
    triggerImageUpload() {
      this.$refs.imageInput.$el.querySelector("input[type='file']").click();
    },
    /**
     * Send accept-invitation request to the API with the token from URL params.
     */
    async acceptInvite() {
      const token = this.$route.params.token;
      if (!token) {
        alert("No token found in URL");
        return;
      }

      // Validate password confirmation
      if (this.form.password !== this.form.confirmPassword) {
        alert("Passwords do not match!");
        return;
      }

      try {
        // Use FormData if you want to handle image upload similarly to the profile
        const formData = new FormData();
        formData.append("username", this.form.username);
        formData.append("password", this.form.password);
        if (this.form.avatarFile) {
          formData.append("image", this.form.avatarFile);
        }

        const response = await api.post(`/api/accept-invitation/${token}/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log(response.data);
        alert("User created! You may now login.");
        this.$router.push("/login");
      } catch (error) {
        console.error(error);
        alert("Error accepting invitation.");
      }
    },
  },
};
</script>

<style scoped>
.circle-image {
  object-fit: cover;
  border-radius: 50%;
  width: 128px;
  height: 128px;
}

.avatar-container {
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: fit-content;
  margin: 0 auto;
}

.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 128px;
  height: 128px;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.avatar-container:hover .hover-overlay {
  opacity: 1;
}
</style>
